module.exports = __webpack_public_path__ + "static/VTCMarsha-Bold-f485e8e729bb54d4a5bf5607360d9300.woff2";